import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './PortfolioStrategy.css';

const PortfolioStrategy = () => {
  return (
    <div className="ps-page">
      {/* --- Section 1: Content & Strategy --- */}
      <section className="ps-section py-5">
        <Container className="pt-5">
          
          {/* Main title with a line */}
          <div className="text-center mb-5">
            <h1 className="ps-main-title">PORTFOLIO STRATEGY</h1>
            <div className="ps-title-line"></div>
          </div>

          <Row className="justify-content-center">
            <Col lg={10}>
              
              <div className="ps-faq-container mb-5">
                <h3 className="ps-section-label mb-4">Common Owner FAQs</h3>
                
                <Accordion className="ps-custom-accordion">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      Why should I hire a professional property management company to manage my rental property?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>If you lack the time or expertise needed for day-to-day management of your commercial or residential real estate investments, an HDPMG property manager can help. HDPMG can help you:</p>
                      <ul className="ps-list">
                        <li>Market your rental property to minimize vacancies and maximize income</li>
                        <li>Fill vacancies with the best possible tenants</li>
                        <li>Navigate and comply with the regulations and legal requirements of the government</li>
                        <li>Maintain and keep your rental property in good condition</li>
                        <li>Collect rent and track tenant deposits</li>
                        <li>Respond to tenant requests and deal with problem tenants</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      In what area do you manage properties?
                    </Accordion.Header>
                    <Accordion.Body>
                      HDPMG currently manages locations in Florida and Arizona with a focus on growth to multiple locations across the country.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      How does maintenance work?
                    </Accordion.Header>
                     <Accordion.Body>
                      <p>This is one of the most popular questions to ask a property manager.
                        And maintenance is always one of the homeowner’s biggest worries.
                        While living in the home, it’s easy for the homeowner to notice what needs to be fixed. They will fix it or they ignore it because it doesn’t bother them.
                        It’s different when dealing with a tenant. When they notice something, they will place a maintenance call into the office. And that’s ok…we want tenants to have a safe, secure, and well-cared-for home.
                        We rely on these tenants along with our quarterly inspections to let us know when the house needs repairs.
                        The process works like this:</p>
                      <ul className="ps-list">
                        <li>The tenant notices something is wrong in the house.</li>
                        <li>The tenant will either call us or fill out an online form to inform us of the problem.</li>
                        <li>One of our technicians will go out and assess the situation.</li>
                        <li>Depending on the assessments of the problem the steps after will change.</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>

              <hr className="ps-divider my-5" />

              {/* Personalized plan part */}
              <div className="ps-plan-container text-center">
                <h2 className="ps-sub-title mb-5">
                  Let’s Build A <span className="highlight-blue">Personalized Plan</span> to Grow Your Business!
                </h2>
                
                <Row className="g-4 text-start">
                  {[
                    "Examine your current real estate investment portfolio/plans to see what’s working and what’s hurting. Discover where you’re making money and losing it.",
                    "Search for the diamonds in your backyard, the low-hanging profit opportunities that can be made with minor tweaks.",
                    "Diagnose the biggest roadblock to scaling your business fast and profitably.",
                    "Present the best path for tweaking your investment game-plan so you can build wealth faster, with more predictability and stability."
                  ].map((text, i) => (
                    <Col md={6} key={i}>
                      <div className="ps-step-box">
                        <div className="ps-step-number">{i + 1}</div>
                        <p className="ps-step-text">{text}</p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>

            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Section 2: Call to Action (CTA) --- */}
      <section className="ps-cta-section py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <h2 className="ps-cta-title mb-4">
                Schedule Your <span className="highlight-blue">PROPERTY PROFITS</span> STRATEGY SESSION
              </h2>
              
              <div className="mt-4">
                <Link 
                    to="/contact-us" 
                    className="ps-strategy-btn">
                  Contact Us Today!
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default PortfolioStrategy;